import { render, staticRenderFns } from "./UseExclude.vue?vue&type=template&id=0faecfef&scoped=true"
import script from "./UseExclude.vue?vue&type=script&lang=js"
export * from "./UseExclude.vue?vue&type=script&lang=js"
import style0 from "./UseExclude.vue?vue&type=style&index=0&id=0faecfef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faecfef",
  null
  
)

export default component.exports